import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { config } from '../config/config'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/map'

@Injectable()
export class AuthService {
  constructor (private api: ApiService) {}

  login (email: string, password: string): Promise<Object> {
    return this.api.post(`${config.api.url}/login`, { email: email, password: password })
  }

  logout () {
    return this.api.get(`${config.api.url}/logout`)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/services/auth.service.ts